import Request from "../helpers/Request"
import config from "../config"

export const auth = async (data) => new Request().post(
    config.pathAPI + `/auth`,
    data,
)